export default class Utils {
  /**
   * Returns a Date object with UTC time zone, with exact same Year, Month, Day, Hour, Minute and Second.
   * Note that this will not convert given Date object to UTC, but rather strip the timezone.
   *
   * @param date Local Date object.
   * @param dateOnly
   */
  static toUtcDate(date: Date, dateOnly = true): Date {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        dateOnly ? 0 : date.getHours(),
        dateOnly ? 0 : date.getMinutes(),
        dateOnly ? 0 : date.getSeconds(),
      ),
    );
  }
}
